// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_hf-0";
export var fulfillmentPanelBody = "_hf-1";